'use client';

import { useEffect } from 'react';
import { useGlobalContext } from '@/store/contexts/global-context';
import { useStore } from '@/store/store';
import { sendExposureEvent } from '@/tracking/amplitude/events/general/experiment-exposure';

/**
 *
 * Anchored at page level (not on the zone) so both arms are captured: treatment and control
 * Only logged-in users are exposed (the feature surface is logged-in only), and
 * `sendExposureEvent` dedupes via a module-level Set so a single exposure persists
 * across client-side navigation for the whole session.
 */
export const ExposureEffects = ({ flagKey }: { flagKey: string }) => {
    const { experiments, isLoggedIn } = useGlobalContext();
    const { sendEvent } = useStore((state) => state.tracking);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        sendExposureEvent(experiments, flagKey, sendEvent);
    }, [experiments, isLoggedIn, sendEvent]);

    return null;
};
